let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4hwCy")).then(() => parcelRequire('gC1BV'));